module.exports = __webpack_public_path__ + "static/img/btn.e08d018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gameinviteRoom/assets/btn.png
// module id = DRRH
// module chunks = 23